// extracted by css-extract-rspack-plugin
export default {"rail":"rail-ih00BX","tabBar":"tabBar-kyA5UC","tab":"tab-bEkDJz","tabActive":"tabActive-PaYCqz","content":"content-C_yNbZ"};